var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"details"}},_vm._l((_vm.getLoopDetails),function(loopDetail,index){return _c('LoopDetail',{key:`detail-${index}`,staticClass:"detail",attrs:{"mode":"exploration","detail":loopDetail,"color":loopDetail.loop.color}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }